import { render, staticRenderFns } from "./studata.vue?vue&type=template&id=200b810c&"
import script from "./studata.vue?vue&type=script&lang=js&"
export * from "./studata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports